import {
  takeLatest, put, call, SagaReturnType,
} from 'redux-saga/effects';

import * as hintActions from '../actions';

export const config = {
  action: [hintActions.show.type, hintActions.hide.type, hintActions.reshow.type],
  method: takeLatest,
};

let requestId: number;

const delay = (id: number, ms: number) => new Promise((resolve) => {
  setTimeout(() => resolve(id), ms);
});

export function* func(action: hintActions.IShowPayload) {
  requestId = Date.now();
  if (hintActions.show.type === action.type || hintActions.reshow.type === action.type) {
    const { delay: delayTime } = action.payload;
    const currentId: SagaReturnType<typeof delay> = yield call(() => delay(requestId, delayTime));
    if (currentId === requestId) {
      yield put(hintActions.showApply());
    }
  }
}
